<template>
  <apollo-mutation
    :mutation="voteMutation"
    class="flex"
    :variables="{id}">

    <template v-slot="{mutate,loading,error}">

      <button v-if='!loading' :disabled='loading || votedData.type'
              @click='doVote(id, "upvote", mutate)'
              class="flex flex-row justify-center items-center p-1"
              :class="votedData.type === 'upvote' ? 'bg-blue-200' : ''"
              >
              <img src="/web_icon_vote_up.svg" alt="" class="object-contain w-3 mr-1">
              <p class="text-xs">{{upvotes}}</p>
      </button>


      <button v-if='!loading' :disabled='loading || votedData.type'
              @click='doVote(id, "downvote", mutate)'
              class="flex flex-row justify-center items-center p-1"
              :class="votedData.type === 'downvote' ? 'bg-blue-200' : ''"
              >
              <img src="/web_icon_vote_down.svg" alt="" class="object-contain w-3 mr-1">
              <p class="text-xs">{{downvotes}}</p>
      </button>

      <div v-if='loading' class="text-xs text-gray-600 text-bold tracking-loose">
        <span class="spinner text-lg mr-4" />
          <span class="truncate">
            Load...
          </span>
      </div>

    </template>
  </apollo-mutation>


</template>
<script>
import gql from 'graphql-tag';
import { ApolloMutation } from 'vue-apollo';


export default {
  props: {
    id: {
      type: String,
      required: true
    },
    upvotes: {
      type: Number,
      required: true
    },
    downvotes: {
      type: Number,
      required: true
    }
  },
  data() {
    const voteMutation = gql(`
      mutation votePost($id: String!, $type: String!) {
        votePost(id: $id, type: $type) {
          id
          upvotes
          downvotes
        }
      }
    `);
    return {
      voteMutation,
      votedData:{},
    }
  },
  methods: {
    async doVote(id, type, mutate) {
      const voted = await mutate({variables: {id, type}})
      this.votedData = {
        type
      }
      return voted;
    },
  }

}
</script>
